import { Components, Theme } from '@mui/material/styles'

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: '0',
      marginTop: '4px',

      '&.MuiDrawer-paper': {
        marginTop: '0',
      },

      '&.MuiDrawer-paperAnchorBottom': {
        borderRadius: '8px 8px 0 0',
      },
    }),
  },
}
